var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotdesking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "currentColor",
    focusable: "false",
    "data-icon": "menu-fold",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.341 1.34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.65 8.127a.65.65 0 0 1-.65-.65v-5.12A2.36 2.36 0 0 1 2.357 0h5.12a.65.65 0 1 1 0 1.3h-5.12A1.058 1.058 0 0 0 1.3 2.357v5.12a.65.65 0 0 1-.65.65z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.962 16.319H4.291a.65.65 0 0 1 0-1.3h9.671a1.058 1.058 0 0 0 1.057-1.057V4.291a.65.65 0 0 1 1.3 0v9.671a2.36 2.36 0 0 1-2.357 2.357z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.477 0h6.485a2.36 2.36 0 0 1 2.357 2.357v1.934a.65.65 0 0 1-.19.46l-4.21 4.21a.65.65 0 0 1-.919 0L5.082 3.044a.65.65 0 0 1 0-.919L7.017.19a.65.65 0 0 1 .46-.19zm7.542 4.022V2.357A1.058 1.058 0 0 0 13.962 1.3H7.746L6.461 2.584l5 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.291 16.319H2.357A2.359 2.359 0 0 1 0 13.963V7.477a.65.65 0 0 1 .19-.46l4.892-4.892a.65.65 0 1 1 .918.92l-4.7 4.7v6.217a1.058 1.058 0 0 0 1.057 1.056h1.665L11 8.041a.65.65 0 0 1 .919.919l-7.168 7.169a.65.65 0 0 1-.46.19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.974 7.055A2.015 2.015 0 1 1 2.958 9.07a2.017 2.017 0 0 1 2.016-2.015zm0 2.73a.715.715 0 1 0-.716-.715.716.716 0 0 0 .716.715z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotdesking);
export default __webpack_public_path__ + "static/media/hotdesking.3c4b5fc573e9502ec8028fcfcccf6b82.svg";
export { ForwardRef as ReactComponent };